const FormReducer = (state, {payload, type}) => {
    switch (type) {
        case 'SET_FIELD':
            return {
                ...state,
                [payload.key]: payload.value
            }
        case 'CHANGE_STORE':
            return {
                ...state,
                store: payload,
            }
        case 'CHANGE_TYPE':
            return {
                ...state,
                formType: payload
            }
        case "FORM_SENDING":
            return {
                ...state,
                sending: true,
                sent: false
            }
        case "FORM_SENT":
            return {
                ...state,
                sending: false,
                sent: true
            }
        case "HIDE_MODAL":
            return {
                ...state,
                sending: false,
                sent: false
            }
        default:
            return state
    }
};

export default FormReducer;
